import React from 'react';
import { useParams } from 'react-router-dom';
import { LoadingPage } from 'components/loading';
import { ErrorPage } from 'components/errors';
import { usePlanInactive } from 'hooks/use-plan-inactive.hook';
import * as States from './states';

export const Usage = () => {
  const { planId } = useParams<{ planId?: string }>();
  const { data, loading, error } = usePlanInactive({
    planId: Number(planId),
  });

  if (loading) return <LoadingPage />;
  if (error || !data) return <ErrorPage />;

  return data.planInactive ? <States.Closed /> : <States.Active />;
};
